import { render, staticRenderFns } from "./select-member-role-setting.vue?vue&type=template&id=1f4ffea1&scoped=true&"
import script from "./select-member-role-setting.vue?vue&type=script&lang=ts&"
export * from "./select-member-role-setting.vue?vue&type=script&lang=ts&"
import style0 from "./select-member-role-setting.vue?vue&type=style&index=0&id=1f4ffea1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4ffea1",
  null
  
)

export default component.exports